// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"bfde16ea","580":"bfde16ea"}[chunkId] + ".chunk.css";
};